<template>
  <div>
    <div class="tabbable-custom mg-bottom-40">
      <ul class="nav nav-tabs nav-justified">
        <li
          :class="{ active: index === 0 }"
          v-for="(item, index) in children"
          :key="index"
        >
          <a
            :href="`#${item.$props.id}`"
            data-toggle="tab"
            class="uppercase"
            v-text="item.$props.label"
          ></a>
        </li>
      </ul>
    </div>
    <div :class="{ container: forPublicView }">
      <div class="tab-content clearfix"><slot></slot></div>
    </div>
  </div>
</template>
<script type="text/babel">
export default {
  name: 'ProfileTabs',
  props: {
    forPublicView: {
      default: false,
      required: false
    }
  },
  computed: {
    children() {
      return this.$children;
    }
  }
};
</script>
